import React, { type MouseEventHandler, type ReactNode } from 'react';

import { FloorActivityCardVariant } from '../../types';

import { StyledCard } from './styles';

export interface CardProps {
    children: ReactNode;
    variant?: FloorActivityCardVariant;
    spaceBefore?: boolean;
    onMouseEnter?: MouseEventHandler;
    onMouseLeave?: MouseEventHandler;
    portable?: boolean;
}

export function Card({
    children,
    variant = FloorActivityCardVariant.Dark,
    spaceBefore = false,
    portable = false,
    onMouseEnter,
    onMouseLeave,
}: CardProps) {
    return (
        <StyledCard
            $portable={portable}
            $variant={variant}
            $spaceBefore={spaceBefore}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {children}
        </StyledCard>
    );
}
